import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '../store/uiSlice';
import { themes } from '../themes/themeConfig';

const useTheme = () => {
  const dispatch = useDispatch();
  const themeName = useSelector((state) => state.ui.theme);
  const currentTheme = themes[themeName] || themes.dark;

  const toggle = () => {
    dispatch(toggleTheme());
  };

  const setTheme = (theme) => {
    if (theme !== themeName) {
      dispatch(toggleTheme());
    }
  };

  return {
    theme: themeName,
    themeConfig: currentTheme,
    isDark: themeName === 'dark',
    isLight: themeName === 'light',
    toggle,
    setTheme,
  };
};

export default useTheme;